import React from 'react';
import { Cloud, Globe, Server } from 'lucide-react';

const InfrastructureSection = ({ 
  formData, 
  handleInputChange, 
  errors, 
  cloudProviders,
  regionOptions
}) => {
  return (
    <div className="mb-6 bg-blue-50 dark:bg-blue-900/20 p-4 rounded-lg border border-blue-200 dark:border-blue-800">
      <h3 className="text-base font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Server className="w-5 h-5 mr-2 text-blue-500" />
        Инфраструктура и размещение
      </h3>
      
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Облачный провайдер */}
        <div>
          <label htmlFor="cloudProvider" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Cloud className="w-4 h-4 mr-2 text-blue-500" />
            Облачный провайдер
          </label>
          <select
            id="cloudProvider"
            name="cloudProvider"
            value={formData.cloudProvider}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.cloudProvider ? 'input-error' : ''}`}
          >
            {cloudProviders.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.name}
              </option>
            ))}
          </select>
          {errors.cloudProvider && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.cloudProvider}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Выбор провайдера влияет на стоимость инфраструктуры.
            {formData.cloudProvider === 'onpremise' && ' On-premise требует больших капитальных затрат.'}
          </p>
        </div>

        {/* Регион размещения */}
        <div>
          <label htmlFor="region" className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1 flex items-center">
            <Globe className="w-4 h-4 mr-2 text-blue-500" />
            Регион размещения
          </label>
          <select
            id="region"
            name="region"
            value={formData.region}
            onChange={handleInputChange}
            className={`form-select w-full ${errors.region ? 'input-error' : ''}`}
          >
            {regionOptions.map((region) => (
              <option key={region.id} value={region.id}>
                {region.name}
              </option>
            ))}
          </select>
          {errors.region && (
            <p className="mt-1 text-xs text-red-500 dark:text-red-400">
              {errors.region}
            </p>
          )}
          <p className="mt-1 text-xs text-gray-600 dark:text-gray-400">
            Регион влияет на стоимость инфраструктуры и персонала
          </p>
        </div>
      </div>

      <div className="mt-4 bg-blue-100 dark:bg-blue-900/30 p-3 rounded-lg border border-blue-200 dark:border-blue-800">
        <div className="flex items-start">
          <Server className="w-5 h-5 text-blue-600 dark:text-blue-400 mr-3 mt-1" />
          <div>
            <h4 className="text-sm font-medium text-blue-700 dark:text-blue-300 mb-1">
              Рекомендация по инфраструктуре
            </h4>
            <p className="text-xs text-blue-600 dark:text-blue-400">
              {formData.projectType === 'realtime' 
                ? 'Для обработки данных в реальном времени рекомендуется использовать производительные сервисы с высокой пропускной способностью.'
                : formData.projectType === 'ml'
                ? 'Для проектов машинного обучения рекомендуется использовать специализированные сервисы с поддержкой GPU/TPU.'
                : formData.projectType === 'datawarehouse'
                ? 'Для хранилищ данных оптимальны решения с высокой горизонтальной масштабируемостью и оптимизированные для аналитических запросов.'
                : 'Выбирайте инфраструктуру в соответствии с объемом данных и требованиями к производительности.'
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InfrastructureSection;